import { Box, Divider, Grid, IconButton, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { formContainer } from "../../container/form.container";
import VSNButton from "../../shared/VSNButton";
import VSNErrorMessage from "../../shared/VSNErrorMessage";
import VSNLabel from "../../shared/VSNLabel";
import VSNTypography from "../../shared/VSNTypography";
import ControlForm from "../../shared/form/ControlForm";
import { DeleteIcon } from "../../shared/icon";
import { uploadDocumentModalContainer } from "../../container/uploadDocumentModal.container";

export const useStyles = makeStyles((theme) => ({
  title: {
    "&.MuiTypography-root": {
      fontWeight: 700,
      lineHeight: "31.25px",
      fontSize: "24px",
      padding: "20px 0",
      whiteSpace: "nowrap",
      marginRight: 32,
      textOverflow: "ellipsis",
      overflow: "hidden",
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
        lineHeight: "26px",
        whiteSpace: "unset",
        "-webkit-line-clamp": "2",
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        padding: 0,
        margin: "20px 32px 20px 0",
      },
    },
  },
  modalHeader: {
    position: "sticky",
    top: 0,
    background: "var(--white)",
    zIndex: 3,
  },
  question: {
    "&.MuiTypography-root": {
      fontWeight: 700,
      lineHeight: "23.44px",
      fontSize: "18px",
      color: "#2D2F39",
      position: "relative",
      display: "inline-block",
      "& .MuiFormLabel-root": {
        position: "absolute",
        left: "100%",
      },
    },
  },
  description: {
    "&.MuiTypography-root": {
      color: "var(--gray)",
      fontWeight: 400,
      lineHeight: "18.23px",
      fontSize: "14px",
      marginTop: 4,
    },
  },
  input: {
    width: "100%",
    "&.css-qv3mbf-MuiFormControl-root-MuiTextField-root .MuiInputBase-root .MuiInputBase-input":
      {
        position: "relative",
        fontSize: 14,
      },
    "& .MuiInputBase-root": {
      "& .Mui-disabled": {
        WebkitTextFillColor: "#202024 !important",
      },
      "& .MuiInputBase-input": {
        padding: "8px 0px",
        width: "700px",
        gap: "8px",
      },
    },
  },
  button_groups: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: "#F6F6FD",
    padding: "20px 25px",
    gap: 10,
    marginLeft: "-25px",
    marginRight: "-25px",
    position: "sticky",
    bottom: 0,
    zIndex: 99,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      padding: "15px",
      gap: 10,
      marginLeft: "-15px",
      marginRight: "-15px",
    },
  },
  button: {
    "&.MuiButtonBase-root": {
      color: "var(--white)",
      padding: "13px 25px",
      minWidth: "150px",
      borderRadius: 10,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
      "& span.icon": {
        marginLeft: 8,
        display: "inline-block",
      },
      "& .content": {
        fontWeight: 500,
        fontSize: 16,
        lineHeight: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      "& .loader": {
        "& .MuiCircularProgress-root": {
          height: "16px !important",
          width: "16px !important",
        },
      },
      "&.link": {
        background: "var(--white)",
        border: "1px solid var(--Tertiary)",
        color: "var(--Tertiary)",
        "& .linkIcon": {
          height: "16px",
          width: "16px",
          display: "inline-block",
          marginRight: 10,
        },
      },
    },
  },
  uploadWrapper: {
    borderRadius: 8,
    padding: "10px 8px",
    backgroundColor: "#F5F5F5",
    position: "relative",
    cursor: "pointer",
    width: "100%",
    "& .MuiTypography-h6": {
      color: "var(--gray)",
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "18px",
      "& span": {
        color: theme.palette.blue.main,
        marginLeft: 4,
      },
    },
    "& input": {
      cursor: "pointer",
    },
    "& $inputUpload": {
      top: 0,
      zIndex: 2,
    },
  },
  inputUpload: {
    position: "absolute",
    inset: 0,
    opacity: 0,
    cursor: "pointer",
    zIndex: 9,
    "& .MuiInputBase-root": {
      height: "100%",
      "& .MuiInputBase-input": {
        padding: 0,
        height: "100%",
        display: "none",
      },
    },
  },
  mainBox: {
    background: "var(--white)",
    borderRadius: 5,
    maxWidth: 1040,
    width: "100%",
    margin: "0 auto",
    position: "relative",
    textAlign: "center",
    zIndex: 2,
  },
  innerBox: {
    flex: 1,
  },
  uploadText: {
    "&.MuiTypography-root": {
      fontSize: 14,
      lineHeight: "28px",
      color: "var(--gray)",
      [theme.breakpoints.down("md")]: {
        lineHeight: "20px",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 12,
        marginTop: 20,
      },
    },
  },
  steptoWrapper: {
    "&.MuiStack-root": {
      "& .MuiGrid-container": {
        justifyContent: "space-between",
        [theme.breakpoints.down("sm")]: {
          flexDirection: "column",
        },
        "& .MuiGrid-item": {
          display: "flex",
          flexDirection: "column",
          width: "calc(50% - 40px)",
          flexBasis: "calc(50% - 40px)",
          maxWidth: "calc(50% - 40px)",
          marginBottom: 30.4,
          [theme.breakpoints.down("sm")]: {
            width: "100%",
            maxWidth: "100%",
            marginBottom: 0,
          },
        },
      },
    },
  },
}));

const renderForm = ({
  uploadDocumentsContainer,
  classes,
  handleChange,
  uploadDocumnetInfo,
  formData,
  formErrors,
  handleRemoveFile,
  highlighted,
  onDragEnter,
  onDragLeave,
}) => {
  return (
    <Grid container columnSpacing={{ md: 3.8, xs: 2 }}>
      {uploadDocumentsContainer?.data
        ?.filter((el) => !el?.hide)
        ?.map(
          (
            {
              type,
              question,
              description,
              value,
              subtitle,
              isRequired,
              md,
              xs,
              lg,
            },
            index
          ) => {
            return (
              <React.Fragment key={index}>
                <Grid item xs={xs || 12} md={md} lg={lg}>
                  <Box key={index} className="innnerBox" pt={3}>
                    {question && (
                      <VSNTypography className={classes.question} variant="h4">
                        {isRequired && <VSNLabel required />}
                        {question}
                      </VSNTypography>
                    )}
                    {description && (
                      <VSNTypography
                        className={classes.description}
                        variant="h6"
                        mb="auto"
                      >
                        {description}
                      </VSNTypography>
                    )}
                    {value?.map(
                      (
                        { isRequired, label, errorMessage, name, ...attribute },

                        index
                      ) => {
                        if (type === "Upload Document") {
                          return (
                            <Stack
                              direction={{ sm: "row", xs: "column" }}
                              alignItems={{ sm: "center", xs: "start" }}
                              mt={1}
                              key={index}
                            >
                              <Box className={classes.mainBox}>
                                <Stack direction={{ sm: "row", xs: "column" }}>
                                  <Stack
                                    className={classes.innerBox}
                                    overflow="hidden"
                                  >
                                    <Stack
                                      direction={{ sm: "row", xs: "column" }}
                                      alignItems={{ sm: "center", xs: "start" }}
                                      key={index}
                                      cursor="pointer"
                                      my={1}
                                      width="100%"
                                    >
                                      <Stack
                                        alignItems="center"
                                        justifyContent="center"
                                        color="var(--primary)"
                                        className={`${classes.uploadWrapper}`}
                                        border={
                                          highlighted
                                            ? "2px dashed var(--primary)"
                                            : "1px solid #CBCBCF"
                                        }
                                        onDragEnter={onDragEnter}
                                        onDragLeave={onDragLeave}
                                      >
                                        <VSNTypography variant="h6">
                                          Drop PDF files here or
                                          <span>Click to upload</span>
                                        </VSNTypography>

                                        <input
                                          type="file"
                                          accept="application/pdf"
                                          id="pdf_upload"
                                          onChange={handleChange}
                                          className={classes.inputUpload}
                                          name={name}
                                        />
                                      </Stack>
                                    </Stack>

                                    {uploadDocumnetInfo?.file && (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          padding: "4px 8px",
                                          marginTop: "4px",
                                          borderRadius: "4px",
                                          backgroundColor: "#E2ECFD",
                                          width: "100%",
                                          overflow: "hidden",
                                        }}
                                      >
                                        <Stack
                                          direction="row"
                                          alignItems="center"
                                          justifyContent="space-between"
                                          width="100%"
                                          overflow="hidden"
                                        >
                                          <VSNTypography
                                            className={classes.uploadText}
                                            textAlign="left"
                                            sx={{
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                            title={
                                              uploadDocumnetInfo?.file?.name
                                            }
                                          >
                                            {uploadDocumnetInfo?.file?.name}
                                          </VSNTypography>

                                          <VSNTypography
                                            className={classes.uploadText}
                                            marginLeft="auto"
                                            whiteSpace="nowrap"
                                            ml={1}
                                          >
                                            {uploadDocumnetInfo?.file?.size
                                              ? (
                                                  uploadDocumnetInfo.file.size /
                                                  (1024 * 1024)
                                                ).toFixed(2)
                                              : "0"}{" "}
                                            Mb
                                          </VSNTypography>
                                        </Stack>

                                        <IconButton
                                          onClick={() => handleRemoveFile()}
                                          color="primary"
                                          aria-label="remove file"
                                          component="span"
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Box>
                                    )}

                                    <VSNErrorMessage
                                      {...{
                                        formError: formErrors?.[name],
                                        errorMessage,
                                      }}
                                    />
                                  </Stack>
                                </Stack>
                              </Box>
                            </Stack>
                          );
                        }

                        return (
                          <Box key={index} width="100%">
                            <ControlForm
                              className={classes.input}
                              {...{
                                ...attribute,
                                onChange: handleChange,
                                name,
                                value: uploadDocumnetInfo?.[name] || "",
                              }}
                            />
                            <VSNErrorMessage
                              {...{
                                formError: formErrors?.[name],
                                errorMessage,
                              }}
                            />
                            <VSNTypography
                              className={classes.questionTitle}
                              variant="h6"
                            >
                              {subtitle}
                            </VSNTypography>
                          </Box>
                        );
                      }
                    )}
                  </Box>
                </Grid>
              </React.Fragment>
            );
          }
        )}
    </Grid>
  );
};

const UploadDocumentModal = ({
  onSuccess,
  pageName,
  endPoint,
  org_id,
  location_id,
  department_id,
  user_id,
  flag,
}) => {
  const {
    formPath,
    uploadDocumnetInfo,
    handleChange,
    loaders,
    buttonsContainer,
    uploadDocumentsContainer,
    onInputChange,
    handleRemoveFile,
    highlighted,
    onDragEnter,
    onDragLeave,
  } = uploadDocumentModalContainer({
    onSuccess,
    pageName,
    endPoint,
    org_id,
    location_id,
    department_id,
    user_id,
    flag,
  });
  const classes = useStyles();
  const { formData, formErrors } = formContainer({ formPath });
  const buttons = buttonsContainer[uploadDocumnetInfo?.step];

  return (
    <Box style={{ position: "relative" }}>
      <Box className={classes.modalHeader}>
        <VSNTypography
          id="modal-modal-title"
          variant="h4"
          component="h2"
          className={classes.title}
        >
          {uploadDocumentsContainer?.label}
        </VSNTypography>
        <Divider
          sx={{
            borderColor: "#EAEDF0",
            marginLeft: { sm: "-25px", xs: "-15px" },
            marginRight: { sm: "-25px", xs: "-15px" },
          }}
        />
      </Box>

      <Stack
        direction={{ sm: "row" }}
        flexWrap="wrap"
        position="relative"
        columnGap={{ sm: 10, xs: 1 }}
        rowGap={{ sm: 2, xs: 1 }}
        className={
          uploadDocumentsContainer[uploadDocumnetInfo?.step] === 1
            ? classes.steptoWrapper
            : ""
        }
        mb={4}
      >
        {renderForm({
          uploadDocumentsContainer,
          classes,
          handleChange,
          uploadDocumnetInfo,
          formData,
          formErrors,
          handleRemoveFile,
          onInputChange,
          highlighted,
          onDragEnter,
          onDragLeave,
        })}
      </Stack>

      <Box className={classes.button_groups}>
        {buttons &&
          buttons?.map(
            (
              {
                label,
                handleClick,
                hasLoader,
                icon,
                className,
                link,
                disabled,
                variant,
              },
              index
            ) => (
              <VSNButton
                isLoading={hasLoader && loaders?.UploadDocumentsLoader}
                className={`${classes.button} ${className}`}
                key={index}
                handleClick={handleClick}
                disabled={disabled}
                variant={variant}
                fullWidth
              >
                <span className="linkIcon">{link}</span>
                {label}
                <span className="icon">{icon}</span>
              </VSNButton>
            )
          )}
      </Box>
    </Box>
  );
};

export default UploadDocumentModal;
